var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_4271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 17.5C10.3683 17.5008 10.2379 17.4755 10.116 17.4258C9.9942 17.376 9.88338 17.3027 9.78994 17.21C9.69621 17.117 9.62182 17.0064 9.57105 16.8846C9.52028 16.7627 9.49414 16.632 9.49414 16.5C9.49414 16.368 9.52028 16.2373 9.57105 16.1154C9.62182 15.9936 9.69621 15.883 9.78994 15.79L13.0999 12.5L9.91994 9.18999C9.73369 9.00263 9.62915 8.74918 9.62915 8.48499C9.62915 8.2208 9.73369 7.96735 9.91994 7.77999C10.0129 7.68626 10.1235 7.61187 10.2454 7.5611C10.3672 7.51033 10.4979 7.48419 10.6299 7.48419C10.762 7.48419 10.8927 7.51033 11.0145 7.5611C11.1364 7.61187 11.247 7.68626 11.3399 7.77999L15.1999 11.78C15.3832 11.9669 15.4858 12.2182 15.4858 12.48C15.4858 12.7417 15.3832 12.9931 15.1999 13.18L11.1999 17.18C11.1102 17.2769 11.0021 17.3551 10.882 17.41C10.7618 17.465 10.632 17.4955 10.4999 17.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_4271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementArrowRight);
export default __webpack_public_path__ + "static/media/icon_settlement_arrow_right.c57e960173c133e0ae1fa96f733df229.svg";
export { ForwardRef as ReactComponent };